import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/shared/Logo";
import { Loader2 } from "lucide-react";

export default function CustomerLogin() {
    const { persistSession } = useAuth();
    const nav = useNavigate();
    const [form, setForm] = useState({ mobile_number: "", password: "" });
    const [submitting, setSubmitting] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            const r = await api.post("/auth/customer/login-mobile", form);
            persistSession(r.data);
            const u = r.data.user;
            if (!u.district_slug) nav("/customer/complete-profile");
            else nav(`/home?district_slug=${u.district_slug}`);
        } catch (e) {
            toast.error(errorMessage(e));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-neutral-950 via-neutral-900 to-neutral-950 px-4 py-10 text-white" data-testid="customer-login">
            <div className="mx-auto flex max-w-md flex-col items-center gap-6">
                <Link to="/">
                    <Logo size={112} variant="lockup" className="sm:hidden" />
                    <Logo size={160} variant="lockup" className="hidden sm:block" />
                </Link>
                <div className="w-full rounded-3xl bg-white p-6 text-neutral-900 shadow-2xl">
                    <div className="mb-4">
                        <div className="text-sm font-medium text-orange-600">Customer login</div>
                        <h1 className="text-2xl font-extrabold">Welcome back</h1>
                    </div>
                    <form className="grid gap-3" onSubmit={submit}>
                        <div>
                            <Label className="text-xs">Mobile number</Label>
                            <div className="flex">
                                <span className="inline-flex items-center rounded-l-md border border-r-0 border-neutral-300 bg-neutral-100 px-2 text-xs text-neutral-500">+91</span>
                                <Input value={form.mobile_number} onChange={(e) => setForm((f) => ({ ...f, mobile_number: e.target.value }))} inputMode="numeric" maxLength={10} className="rounded-l-none" required data-testid="login-mobile" />
                            </div>
                        </div>
                        <div>
                            <Label className="text-xs">Password</Label>
                            <Input type="password" value={form.password} onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))} required data-testid="login-password" />
                        </div>
                        <Button type="submit" disabled={submitting} className="btn-primary mt-2 h-11 justify-center text-base font-semibold" data-testid="login-submit">
                            {submitting && <Loader2 size={16} className="mr-2 animate-spin" />}
                            Login
                        </Button>
                    </form>
                    <p className="mt-4 text-center text-xs text-neutral-500">
                        No account yet? <Link to="/customer/register" className="font-semibold text-orange-600 hover:underline">Create one</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}
